import {
    FETCH_PROJECT_DOCUMENT,
    FETCH_PROJECT_BACKGROUND_INFORMATION,
    FETCH_ALL_PROJECT_LIST,
    FETCH_MAIN_QUOTATION,
    FETCH_DOCUMENT_LIST,
    FETCH_DOCUMENT_CONTENT,
    FETCH_TEMPLATE_LIST,
    FETCH_TEMPLATE_CONTENT,
    FETCH_PROJECT_SUMMARY,
    UPDATE_SELECTED_PROJECT,
    UPDATE_LOADING_STATUS,
    UPDATE_ITEM_LIST,
    UPDATE_UNIT_LIST,
    UPDATE_AVILABLE_CONTACT_PERSON_LIST,
    UPDATE_ITEM_SMART_SUGGESTION_LIST,
    UPDATE_PROJECT_DUE,
    UPDATE_PROJECT_DOCUMENT_DUE,
    REQUEST_REDIRECT,
    UPDATE_LOCATION_LIST,
    UPDATE_ESTATE_LIST
} from '../ActionTypes'
import _ from 'lodash'
import download from 'downloadjs'

const API_URL = process.env.API_URL

const startLoadingScreen = (lodaingText) => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: true,
            tip: `${lodaingText}...`
        }
    }
}

const endLoadingScreen = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: false
        }
    }
}

// FETCH Project Background Information
const requestProjectBackgroundInformation = () => {
    return {
        type: FETCH_PROJECT_BACKGROUND_INFORMATION,
        payload: {}
    }
}

const receiveProjectBackgroundInformation = (json) => {
    return {
        type: FETCH_PROJECT_BACKGROUND_INFORMATION,
        payload: json
    }
}

export const fetchProjectBackgrounInformation = (token, projectId) => {
    return dispatch => {
        dispatch(startLoadingScreen('Importing'))
        dispatch(requestProjectBackgroundInformation())
        return fetch(`${API_URL}/project/${projectId}/background-information`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveProjectBackgroundInformation(json.result)))
            .then(() => dispatch(endLoadingScreen()))
    }
}

export const fetchTemplateBackgrounInformation = (token, templateId) => {
    return dispatch => {
        dispatch(startLoadingScreen('Importing'))
        dispatch(requestProjectBackgroundInformation())
        return fetch(`${API_URL}/template/${templateId}/background-information`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveProjectBackgroundInformation(json.result)))
            .then(() => dispatch(endLoadingScreen()))
    }
}


// FETCH All Project List
const requestAllProjectList = () => {
    return {
        type: FETCH_ALL_PROJECT_LIST,
        payload: []
    }
}

const receiveAllProjectList = (array) => {
    return {
        type: FETCH_ALL_PROJECT_LIST,
        payload: array
    }
}

export const fetchAllProjectList = (token) => {
    return dispatch => {
        dispatch(requestAllProjectList())
        return fetch(`${API_URL}/project?status=all`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveAllProjectList(json.result)))
    }
}

// FETCH Project Summary
const requestProjectSummary = () => {
    return {
        type: FETCH_PROJECT_SUMMARY,
        payload: []
    }
}

const receiveProjectSummary = (array) => {
    return {
        type: FETCH_PROJECT_SUMMARY,
        payload: array
    }
}

export const fetchProjectSummary = (token, projectId) => {
    return dispatch => {
        dispatch(requestProjectSummary())
        return fetch(`${API_URL}/project/${projectId}/project-summary`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveProjectSummary(json.result)))
    }
}

// EXPORT AND DOWNLOAD pdf
export const exportPDF = (token, projectId, documentId, type, paymentId) => {
    return dispatch => {
        dispatch(startLoadingScreen('Exporting'))
        return fetch(`${API_URL}/project/${projectId}/document/${documentId}/export${type ? '?type=' + type : ''}${type === 'invoice' || type === 'receipt' ? '&payment_id=' + paymentId : ''}`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/pdf'
                }
            })
            .then(response => response.json())
            .then(json => {
                download(json.result.content, json.result.filename)
                dispatch(endLoadingScreen())
            })
    }
}


// FETCH/UPDATE Template
export const saveTemplate = (token, backgroundInformation, content, termsAndConditions) => {
    return dispatch => {
        dispatch(startLoadingScreen('Saving'))
        return fetch(`${API_URL}/template`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ backgroundInformation, content, termsAndConditions })
            })
            .then(response => response.json())
            .then(json => dispatch(endLoadingScreen()))
    }
}

// FETCH Estate List
const requestEstateList = () => {
    return {
        type: UPDATE_ESTATE_LIST,
        payload: []
    }
}

const receiveEstateList = (array) => {
    return {
        type: UPDATE_ESTATE_LIST,
        payload: array
    }
}

export const fetchEstateList = (token) => {
    return dispatch => {
        dispatch(requestEstateList())
        return fetch(`${API_URL}/suggest/estate`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveEstateList(json.result)))
    }
}

// FETCH Location List
const requestLocationList = () => {
    return {
        type: UPDATE_LOCATION_LIST,
        payload: []
    }
}

const receiveLocationList = (array) => {
    return {
        type: UPDATE_LOCATION_LIST,
        payload: array
    }
}

export const fetchLocationList = (token) => {
    return dispatch => {
        dispatch(requestLocationList())
        return fetch(`${API_URL}/suggest/location`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveLocationList(json.result)))
    }
}

// Export Document
export const exportDocument = (token) => {
    return fetch(`${API_URL}/export`, {
            mode: 'cors',
            headers: {
                'Authorization': `bearer ${token}`,
                'Content-Type': 'application/pdf',
            }
        })
        .then(response => console.log(response))
}

// Fetch Document List
const requestDocumentList = () => {
    return {
        type: FETCH_DOCUMENT_LIST,
        payload: []
    }
}

const receiveDocumentList = (array) => {
    return {
        type: FETCH_DOCUMENT_LIST,
        payload: array
    }
}

export const fetchDocumentList = (token, projectId, type) => {
    return dispatch => {
        dispatch(requestDocumentList())
        return fetch(`${API_URL}/project/${projectId}/document?type=${type}`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                dispatch(receiveDocumentList(json.result))
            })
    }
}

// Fetch Document Content
const showLoadingDocument = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: true,
            tip: 'Loading Document...'
        }
    }
}

const hideLoadingDocument = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: false
        }
    }
}

const requestDocumentContent = () => {
    return {
        type: FETCH_DOCUMENT_CONTENT,
        payload: {}
    }
}

const receiveDocumentContent = (json) => {
    return {
        type: FETCH_DOCUMENT_CONTENT,
        payload: json
    }
}

export const fetchDocumentContent = (token, projectId, documentId) => {
    return dispatch => {
        dispatch(showLoadingDocument())
        dispatch(requestDocumentContent())
        return fetch(`${API_URL}/project/${projectId}/document/${documentId}`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveDocumentContent(json.result)))
            .then(() => dispatch(hideLoadingDocument()))
    }
}



// Fetch Templatae List
const requestTemplateList = () => {
    return {
        type: FETCH_TEMPLATE_LIST,
        payload: []
    }
}

const receiveTemplateList = (array) => {
    return {
        type: FETCH_TEMPLATE_LIST,
        payload: array
    }
}

export const fetchTemplateList = (token) => {
    return dispatch => {
        dispatch(requestTemplateList())
        return fetch(`${API_URL}/template`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                dispatch(receiveTemplateList(json.result))
            })
    }
}

// Fetch Tempalate Content
const showLoadingTemplate = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: true,
            tip: 'Loading Template...'
        }
    }
}

const hideLoadingTemplate = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: false
        }
    }
}

const requestTemplateContent = () => {
    return {
        type: FETCH_TEMPLATE_CONTENT,
        payload: {}
    }
}

const receiveTemplateContent = (json) => {
    return {
        type: FETCH_TEMPLATE_CONTENT,
        payload: json
    }
}

export const fetchTemplateContent = (token, templateId) => {
    return dispatch => {
        dispatch(showLoadingTemplate())
        dispatch(requestTemplateContent())
        return fetch(`${API_URL}/template/${templateId}`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveTemplateContent(json.result)))
            .then(() => dispatch(hideLoadingTemplate()))
    }
}

// FETCH item smart suggestion list
const requestItemSmartSuggestionList = () => {
    return {
        type: UPDATE_ITEM_SMART_SUGGESTION_LIST,
        payload: {
            loading: true,
            suggestionList: []
        }
    }
}

const receiveItemSmartSuggestionList = (keyword, array) => {
    return {
        type: UPDATE_ITEM_SMART_SUGGESTION_LIST,
        payload: {
            loading: false,
            keyword: keyword,
            suggestionList: array
        }
    }
}

export const fetchItemSmartSuggestionList = (token, keyword, filter) => {
    return dispatch => {
        const filterQuery = _.map(filter, (value, key) => {
            if (value !== undefined)
                return `${key}=${encodeURIComponent(value)}`
        })
        dispatch(requestItemSmartSuggestionList())
        return fetch(`${API_URL}/suggest/smart-item?keyword=${encodeURIComponent(keyword)}${filterQuery.length > 0 ? '&' + filterQuery.join('&'): ''}`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveItemSmartSuggestionList(keyword, json.result)))
    }
}

// FETCH item list
const requestItemList = () => {
    return {
        type: UPDATE_ITEM_LIST,
        payload: []
    }
}

const receiveItemList = (array) => {
    return {
        type: UPDATE_ITEM_LIST,
        payload: array
    }
}

export const fetchItemList = (token) => {
    return dispatch => {
        dispatch(requestItemList)
        return fetch(`${API_URL}/suggest/item`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveItemList(json.result)))
    }
}

export const removeItemName = (token, itemName) => {
    return dispatch => {
        return fetch(`${API_URL}/suggest/item`, {
                method: 'DELETE',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ item: itemName })
            })
            .then(response => response.json())
            .then(json => fetch(`${API_URL}/suggest/item`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }))
            .then(response => response.json())
            .then(json => dispatch(receiveItemList(json.result)))
    }
}

// FETCH unit list
const requestUnitList = () => {
    return {
        type: UPDATE_UNIT_LIST,
        payload: []
    }
}

const receiveUnitList = (array) => {
    return {
        type: UPDATE_UNIT_LIST,
        payload: array
    }
}

export const fetchUnitList = (token) => {
    return dispatch => {
        dispatch(requestUnitList)
        return fetch(`${API_URL}/suggest/unit`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveUnitList(json.result)))
    }
}

// FETCH available contact person list
const requestAvailableContactPersonList = () => {
    return {
        type: UPDATE_AVILABLE_CONTACT_PERSON_LIST,
        payload: []
    }
}

const receiveAvailableContactPersonList = (array) => {
    return {
        type: UPDATE_AVILABLE_CONTACT_PERSON_LIST,
        payload: array
    }
}

export const fetchAvailableContactPersonList = (token, projectId) => {
    return dispatch => {
        dispatch(requestAvailableContactPersonList())
        return fetch(`${API_URL}/project/${projectId}/member/contact-available`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveAvailableContactPersonList(json.result)))
    }
}

export const clearAvailableContactPersonList = () => {
    return dispatch => dispatch(requestAvailableContactPersonList())
}

// REQUEST redirect
export const requestRedirect = (target) => {
    return {
        type: REQUEST_REDIRECT,
        payload: target
    }
}

// FETCH Project
const requestProject = () => {
    return {
        type: UPDATE_SELECTED_PROJECT,
        payload: {}
    }
}

const receiveProject = (project) => {
    return {
        type: UPDATE_SELECTED_PROJECT,
        payload: project
    }
}

const fetchProject = (token, projectId) => {
    return fetch(`${API_URL}/project/${projectId}`, {
            mode: 'cors',
            headers: {
                'Authorization': `bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
}

export const loadProject = (token, projectId) => {
    return dispatch => {
        dispatch(requestProject())
        return fetchProject(token, projectId)
            .then(json => {
                if (json.success)
                    dispatch(receiveProject(json.result))
            })
            .then(dispatch(fetchAvailableContactPersonList(token, projectId)))
    }
}

export const reloadProject = (token, projectId) => {
    return dispatch => {
        return fetchProject(token, projectId)
            .then(json => {
                if (json.success)
                    dispatch(receiveProject(json.result))
            })
            .then(dispatch(fetchAvailableContactPersonList(token, projectId)))
    }
}

export const createDocument = (token, projectId, documentContent) => {
    return dispatch => {
        return fetch(`${API_URL}/project/${projectId}/document`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(documentContent)
            })
            .then(response => response.json())
            .then(json => dispatch(requestRedirect(`/workdesk/project/${json.result.project_id}/document/${json.result._id}`)))
            .then(() => dispatch(requestRedirect('')))
            .then(() => dispatch(reloadProject(token, projectId)))
    }
}

export const createWPR = (token, projectId, sections, noticeSections, wpId, wpDocumentContent) => {
    return dispatch => {
        dispatch(startLoadingScreen('Generating'))

        return fetch(`${API_URL}/project/${projectId}/document/${wpId}`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(wpDocumentContent)
            })
            .then(response => response.json())
            .then(() => fetch(`${API_URL}/project/${projectId}/document/work-progress-report`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ sections, noticeSections })
            }))
            .then(response => response.json())
            .then(json => dispatch(requestRedirect(`/workdesk/project/${json.result.project_id}/document/${json.result._id}`)))
            .then(() => dispatch(requestRedirect('')))
            .then(() => dispatch(reloadProject(token, projectId)))
            .then(() => dispatch(endLoadingScreen()))
    }
}

// CREATE new project
const requestCreateProject = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: true,
            tip: 'Saving...'
        }
    }
}

const receiveCreateProjectResult = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: false
        }
    }
}

export const createProject = (token, backgroundInformation, documentContent) => {
    return dispatch => {
        dispatch(requestCreateProject())
        return fetch(`${API_URL}/project`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(backgroundInformation)
            })
            .then(response => response.json())
            .then(json => {
                if (json.success)
                    return dispatch(createDocument(token, json.result._id, documentContent))
            })
            .then(() => dispatch(fetchItemList(token)))
            .then(() => dispatch(receiveCreateProjectResult()))
    }
}

// FETCH Document Content
const requestProjectDocument = () => {
    return {
        type: FETCH_PROJECT_DOCUMENT,
        payload: {}
    }
}

const receiveProjectDocument = (json) => {
    return {
        type: FETCH_PROJECT_DOCUMENT,
        payload: json
    }
}

export const fetchProjectDocument = (token, projectId, documentId) => {
    return dispatch => {
        dispatch(requestProjectDocument())
        return fetch(`${API_URL}/project/${projectId}/document/${documentId}`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveProjectDocument(json.result)))
    }
}

// FETCH Document Content for Importing
const requestMainQuotation = () => {
    return {
        type: FETCH_MAIN_QUOTATION,
        payload: {}
    }
}

const receiveMainQuotation = (json) => {
    return {
        type: FETCH_MAIN_QUOTATION,
        payload: json
    }
}

export const fetchMainQuotation = (token, projectId) => {
    return dispatch => {
        dispatch(requestMainQuotation())
        return fetch(`${API_URL}/project/${projectId}/main-quotation`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveMainQuotation(json.result)))
    }
}

// Create/Update Document Content
const requestDocumentChange = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: true,
            tip: 'Saving...'
        }
    }
}

const receiveDocumentChangeResult = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: false
        }
    }
}

const updateDocumentBackgroundInformation = (token, projectId, backgroundInformation) => {
    return dispatch => {
        return fetch(`${API_URL}/project/${projectId}`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(backgroundInformation)
            })
            .then(response => response.json())
    }
}

const updateDocumentContent = (token, projectId, documentId, documentContent) => {
    return dispatch => {
        return fetch(`${API_URL}/project/${projectId}/document/${documentId}`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(documentContent)
            })
            .then(response => response.json())
            .then(json => dispatch(receiveProjectDocument(json.result)))
    }
}

export const updateProjectBgInfo = (token, projectId, backgroundInformation) => {
    return dispatch => {
        dispatch(requestDocumentChange())
        return dispatch(updateDocumentBackgroundInformation(token, projectId, backgroundInformation))
            .then(() => fetchProject(token, projectId)
                .then(json => dispatch(receiveProject(json.result))))
            .then(() => dispatch(fetchEstateList(token)))
            .then(() => dispatch(fetchLocationList(token)))
            .then(() => dispatch(receiveDocumentChangeResult()))
    }
}

export const updateDocumentContentWithBgInfo = (token, projectId, backgroundInformation, documentId, documentContent) => {
    return dispatch => {
        dispatch(requestDocumentChange())
        return dispatch(updateDocumentBackgroundInformation(token, projectId, backgroundInformation))
            .then(() => fetchProject(token, projectId)
                .then(json => dispatch(receiveProject(json.result))))
            .then(() => dispatch(updateDocumentContent(token, projectId, documentId, documentContent)))
            .then(() => dispatch(fetchItemList(token)))
            .then(() => dispatch(fetchEstateList(token)))
            .then(() => dispatch(fetchLocationList(token)))
            .then(() => dispatch(receiveDocumentChangeResult()))
    }
}

export const updateDocumentContentWithoutBgInfo = (token, projectId, documentId, documentContent) => {
    return dispatch => {
        dispatch(requestDocumentChange())
        return dispatch(updateDocumentContent(token, projectId, documentId, documentContent))
            .then(() => fetchProject(token, projectId)
                .then(json => dispatch(receiveProject(json.result))))
            .then(() => dispatch(fetchItemList(token)))
            .then(() => dispatch(receiveDocumentChangeResult()))
    }
}

// Void Document
export const voidDocument = (token, projectId, documentId) => {
    return dispatch => {
        dispatch(requestDocumentChange())
        return fetch(`${API_URL}/project/${projectId}/document/${documentId}/void`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveProjectDocument(json.result)))
            .then(() => fetchProject(token, projectId)
                .then(json => dispatch(receiveProject(json.result))))
            .then(() => dispatch(fetchItemList(token)))
            .then(() => dispatch(receiveDocumentChangeResult()))
    }
}

// Update Due of Project
const receiveProjectDue = (due) => {
    return {
        type: UPDATE_PROJECT_DUE,
        payload: due
    }
}

export const updateProjectDue = (token, projectId, due) => {
    return dispatch => {
        dispatch(requestDocumentChange())
        return fetch(`${API_URL}/project/${projectId}/due`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ due })
            })
            .then(response => response.json())
            .then(json => dispatch(receiveProjectDue(json.result)))
            .then(() => dispatch(receiveDocumentChangeResult()))
    }
}

const receiveDocumentDue = (due) => {
    return {
        type: UPDATE_PROJECT_DOCUMENT_DUE,
        payload: due
    }
}

export const updateDocumentDue = (token, projectId, documentId, due) => {
    return dispatch => {
        dispatch(requestDocumentChange())
        return fetch(`${API_URL}/project/${projectId}/document/${documentId}/due`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ due })
            })
            .then(response => response.json())
            .then(json => dispatch(receiveDocumentDue(json.result)))
            .then(() => dispatch(receiveDocumentChangeResult()))
    }
}


// WEBPACK FOOTER //
// ./src/ProjectDocumentPage/ProjectDocumentPageActions.js